<script setup>

import EmptyCardComponent from "@/components/cards/EmptyCardComponent.vue";
import { computed, ref } from "vue";
import BasicButtonComponent from "@/components/form/BasicButtonComponent.vue";
import { StarIcon } from "@heroicons/vue/16/solid";
import TextAreaComponent from "@/components/form/TextAreaComponent.vue";
import TextInputComponent from "@/components/form/TextInputComponent.vue";
import { useAuthStore } from "@/stores/auth";
import { useBusinessStore } from "@/stores/business";

const authStore = useAuthStore(),
  isAuthenticated = computed(() => !authStore.guest),
  review = ref(Object, null),
  saveReview = () => {
    if (review.value.rating === null || review.value.title === null || review.value.content === null) return alert("Review can't be empty");
    useBusinessStore().addReview({
      business_id	: useBusinessStore().business.id,
      rating: rating.value,
      title: review.value.title,
      content: review.value.content,
    }).then(() => {
      if (useBusinessStore().error) return alert(useBusinessStore().error);
      alert("Review added successfully");
      review.value = null
    })
  },
  ratings = ref([false, false, false, false, false]),
  rating =  ref(Number, 0),
  handleClick = () => {
      for (let i = 0; i < rating.value; i++) {
        ratings.value[i] = true;
      }
    },
    resetRatings = () => {
      for (let i = 0; i < 5; i++) {
        ratings.value[i] = false;
      }
      rating.value = 0;
    },
    handleEnter = (index) => {
      if (rating.value) resetRatings();

      const index2 = index + 1;
      for (let i = 0; i < index2; i++) {
        ratings.value[i] = true;
      }
    },
    handleMouseLeave = (index) => {
      if (rating.value) return;
      for (let i = 0; i <= index; i++) {
        ratings.value[i] = false;
      }
    }
</script>

<template>
  <div
    v-if="!isAuthenticated"
    class="mb-5 text-left"
  >
    <router-link
      to="/login"
      class="
        bg-yellow-400
        text-white
        uppercase
        text-sm
        py-3
        px-4
        rounded-md
        font-semibold
        shadow-md
        hover:shadow-none
        transition-all
        duration-500
        hover:bg-yellow-500
      "
    >
      Login to write review
    </router-link>
  </div>
  <div
    v-else
    class="mb-4"
  >
    <h3 class="text-left">
      Add your Review
    </h3>
    <empty-card-component class="shadow-none bg-transparent">
      <template #body>
        <form @submit.prevent="saveReview">
          <div class="my-4 flex">
            <label
              v-for="(star, index) in ratings"
              :key="index"
              :for="`star-${index}`"
            >
              <star-icon
                :id="`start-${index}`"
                :key="index"
                :class="['h-8 w-8 rating cursor-pointer', star ? 'text-amber-500' : '']"
                @mouseenter="handleEnter(index, $event.target)"
                @mouseleave="handleMouseLeave(index, $event.target)"
                @click="handleClick()"
              />
              <input
                :id="`star-${index + 1}`"
                :key="index"
                v-model="rating"
                type="radio"
                name="rating"
                class="hidden"
                :value="index + 1"
              >
            </label>
          </div>
          <text-input-component
            v-model:input-value="review.title"
            placeholder="Review title"
            type="text"
            class="rounded-xl mb-4 py-4 text-lg"
          />
          <text-area-component
            v-model:textarea-value="review.content"
            placeholder="Write your review"
            class="rounded-xl"
            row="5"
          />
          <basic-button-component
            class="text-sm
                block
                ml-auto
                mt-3
                bg-green-600
                hover:bg-green-500
                transition-all
                duration-500
                text-white
                border
                font-semibold
                drop-shadow"
            type="submit"
          >
            Submit review
          </basic-button-component>
        </form>
      </template>
    </empty-card-component>
  </div>
</template>

<style scoped></style>
